import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 16.965H0.300003V33.93H66V16.965Z" fill="#0052B4" />
    <path d="M66 33.929H0.300003V51H66V33.929Z" fill="#D80027" />
    <path d="M66 0H0.300003V16.965H66V0Z" fill="white" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
